// 📄 components/StepPODistModel.tsx
import React from 'react';
import { Network } from 'lucide-react';
import { PurchaseOrderFormData } from '../../../../../services/commerce/integrationService';

interface StepPODistModelProps {
  distModelName: string;
  senderLogicalSystem: string;
  receiverLogicalSystem: string;
  onChange: (field: keyof PurchaseOrderFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepPODistModel({ distModelName, senderLogicalSystem, receiverLogicalSystem, onChange, isInvalid }: StepPODistModelProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      {/* SPRO Route */}
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">BD64</span> 
          <span>SPRO → Integration with Other SAP Components → SAP Ariba Cloud Integration Gateway → Global Settings → Maintain Distribution Model</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">3. Distribution Model (Modelo de Distribución)</h3>
        <p className="text-sm text-gray-400">
          Define el modelo de distribución lógica en la transacción <code className="bg-black/30 px-1 rounded">BD64</code> para permitir que el flujo de ALE/IDoc transfiera las órdenes de compra del emisor al receptor.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Nombre del Modelo <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={distModelName}
            onChange={(e) => onChange('distModelName', e.target.value.toUpperCase())}
            placeholder="ej. ARIBA_PO"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500 ${
              isInvalid && !distModelName ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Sistema Lógico Emisor <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={senderLogicalSystem}
            onChange={(e) => onChange('senderLogicalSystem', e.target.value.toUpperCase())}
            placeholder="ej. ERP_DEV"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500 ${
              isInvalid && !senderLogicalSystem ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Sistema Lógico Receptor (Ariba) <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={receiverLogicalSystem}
            onChange={(e) => onChange('receiverLogicalSystem', e.target.value.toUpperCase())}
            placeholder="ej. ARIBACIG"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500 ${
              isInvalid && !receiverLogicalSystem ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>
      </div>

      <div className="bg-zinc-850 border border-white/5 rounded-xl p-4 text-gray-300 flex gap-3 text-sm">
        <Network className="w-5 h-5 text-blue-400 flex-shrink-0" />
        <div>
          <p className="font-semibold">Filtros de Distribución</p>
          <p className="text-xs text-gray-400 mt-0.5">
            Recuerde agregar el método de BAPI u objeto de mensaje <code className="bg-black/30 px-1 rounded">ORDERS</code> al modelo y guardarlo. Esto es indispensable para asegurar que el motor ALE reconozca el receptor correcto al procesar la salida.
          </p>
        </div>
      </div>
    </div>
  );
}
